import React from "react";

export function AuditLogPage() {
  return (
    <div className="page-container">
      <div className="content">
        <h1>🔍 Audit Log</h1>
        <p>View system-wide audit logs, track all actions and changes.</p>
        <p style={{ color: "#7f8c8d", marginTop: "20px", fontSize: "14px" }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
